Ext.define('SA.FetchRequest', {
    constructor(cfg) {
        this.cfg = cfg;
    },

    invokeCallback(name, ...args) {
        Ext.callback(this.cfg[name], this.cfg.scope, args);
    },

    onFailure(error) {
        if (this.cfg.failure) {
            this.invokeCallback('failure', error);
        }
        else if (SA.AjaxError.hasInstance(error) && !this.cfg.expectedErrors?.some(type => error.hasType(type))) {
            error.flagUnexpected();
        }

        throw error;
    },

    onFetchError(error) {
        throw SA.AjaxError.getFetchError(error);
    },

    onSuccess(result) {
        this.invokeCallback('success', result);
        return result;
    },

    send() {
        var request = fetch(this.cfg.url, {
            method: this.cfg.httpMethod,
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(this.cfg.data)
        });

        if (this.cfg.blob) {
            return request
                .catch(error => this.onFetchError(error))
                .then(response => {
                    if (response.ok) {
                        return response.blob();
                    }

                    throw SA.AjaxError.getStatusNotOkError();
                })
                .then(blob => this.onSuccess(blob))
                .catch(error => this.onFailure(error));
        }

        return request
            .catch(error => this.onFetchError(error))
            .then(response => {
                return response.json()
                    .catch(error => {
                        throw SA.AjaxError.getJsonParseError({cause: error});
                    })
                    .then(json => {
                        if (response.ok) {
                            return this.onSuccess(json);
                        }

                        throw SA.AjaxError.get(json);
                    });
            })
            .catch(error => this.onFailure(error))
            .finally(() => this.invokeCallback('callback'));
    },

    unresolving() {
        return SA.Promise.unresolving();
    }
});
